export default __webpack_public_path__ + "static/media/yofi-plant-based-milk-vegshelf.4658bfd6.png";